module.exports = __webpack_public_path__ + "static/media/201-martinique.7d83330f.svg";